"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AppMarketSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14,14 C14,14.5522847 13.5522847,15 13,15 L6,15 C5.44771525,15 5,14.5522847 5,14 L5,10 C3.5866926,10 2.6274232,8.8593531 3.13851742,7.21685102 C3.80583831,5.07228367 4.12909339,4 4.10828264,4 L14.8867633,4 L15.914237,7.20806525 C16.2843673,8.79327005 15.381981,10 14,10 L14,14 Z M13,9.75599205 C12.8183506,9.65680393 12.6518781,9.52800825 12.5016603,9.37076727 C12.1088908,9.78332166 11.6016194,10 11,10 C10.3992613,10 9.89370696,9.78387285 9.50376991,9.37251431 C9.1086247,9.78399267 8.60079918,10 8,10 C7.40921101,10 6.90970118,9.78102247 6.52029803,9.36551817 C6.36323979,9.52775209 6.18942977,9.65991776 6,9.76080451 L6,14 L13,14 L13,9.75599205 Z M4.10800306,7.46199622 C3.77047768,8.5225241 4.29861091,9 5,9 C5.47377033,9 5.8175484,8.77507578 6.08634171,8.26639959 C6.23939514,7.94030762 6.78124885,7.88625314 6.97513415,8.2754024 C7.2289786,8.7802902 7.55229974,9 8,9 C8.47125003,9 8.80590556,8.77807548 9.06218666,8.27355538 C9.2727356,7.88565063 9.78309631,7.92759705 9.95660476,8.27925829 C10.203221,8.78048033 10.5307509,9 11,9 C11.4702535,9 11.8013477,8.77927053 12.0527864,8.2763932 C12.271225,7.8894043 12.7706757,7.93257141 12.9458287,8.27364467 C13.2021362,8.77846714 13.5344355,9 14,9 C14.6585364,9 15.2890902,8.44741137 14.9404297,7.43544006 C14.4888388,6.12471811 14.4968524,6.13350388 14.1129969,5 L4.8915621,5 C4.10828264,7.44422582 4.8915621,5 4.10800306,7.46199622 Z" })));
};
AppMarketSmall.displayName = 'AppMarketSmall';
exports.default = AppMarketSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AppMarketSmall.js.map